import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { fmtClabe } from "@/lib/format";

const STYLES = {
  aprobado: "bg-emerald-50 text-emerald-800 border-emerald-200",
  liquidada: "bg-emerald-50 text-emerald-800 border-emerald-200",
  activa: "bg-emerald-50 text-emerald-800 border-emerald-200",
  en_revision: "bg-amber-50 text-amber-800 border-amber-200",
  pendiente: "bg-amber-50 text-amber-800 border-amber-200",
  bloqueada: "bg-amber-50 text-amber-800 border-amber-200",
  rechazado: "bg-red-50 text-red-800 border-red-200",
  devuelta: "bg-red-50 text-red-800 border-red-200",
  cancelada: "bg-slate-100 text-slate-600 border-slate-200",
};

export const StatusBadge = ({ status, label, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
    {label || status}
  </span>
);

export const TipoBadge = ({ tipo }) => (
  <span className={`inline-flex rounded-md px-2 py-0.5 text-[11px] font-semibold tracking-wide ${tipo === "PM" ? "bg-slate-900 text-white" : "bg-teal-100 text-teal-800"}`}>
    {tipo}
  </span>
);

export const ClabeCopy = ({ clabe, testId }) => {
  const [done, setDone] = useState(false);
  const copy = (e) => {
    e.stopPropagation();
    navigator.clipboard?.writeText(clabe);
    setDone(true);
    toast.success("CLABE copiada");
    setTimeout(() => setDone(false), 1500);
  };
  return (
    <button data-testid={testId} onClick={copy} className="group inline-flex items-center gap-2 font-mono text-sm text-slate-800 hover:text-teal-700 transition-colors">
      {fmtClabe(clabe)}
      {done ? <Check className="h-3.5 w-3.5 text-teal-600" /> : <Copy className="h-3.5 w-3.5 opacity-40 group-hover:opacity-100" />}
    </button>
  );
};

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between rise">
    <div>
      <h1 className="text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);
